import React, { useCallback } from 'react';
import { api } from '../api';
import SalesBoard from '../components/SalesBoard';

export default function RosePage() {
  const load = useCallback(() => api.getRoseCafeFood(), []);
  return (
    <SalesBoard
      kicker="Cafe food"
      documentTitle="Rose"
      emptyMessage="No cafe food on the menu."
      load={load}
    />
  );
}
